import type { AllRouteEndpoints } from "../routeTypes";
export const appsMultiLanguageSettingsDownloadTranslationTemplateCacheKeys: AllRouteEndpoints[] = [];
